var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppLogo = function SvgAppLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#212221"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8353 30.9392C17.6606 28.1116 19.4079 24.2051 19.4079 19.8895C19.4079 15.575 17.6606 11.6674 14.8353 8.83978L11.5532 12.1247C13.513 14.0862 14.7347 16.7854 14.7665 19.7713V19.8895C14.7665 22.9215 13.5387 25.6672 11.5532 27.6544L14.8353 30.9392Z",
    fill: "#F5F3F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6027 27.152C12.4599 25.2933 13.6087 22.7255 13.6087 19.8897C13.6087 17.0538 12.4599 14.4861 10.6027 12.6273L7.29282 15.941C8.26608 16.9151 8.88101 18.2467 8.92413 19.7212C8.92928 19.7458 8.93235 19.7705 8.93235 19.7962C8.93235 19.8167 8.9303 19.8383 8.92722 19.8578V19.8897C8.92722 21.432 8.30199 22.8274 7.29282 23.8385V23.8393L10.6027 27.152Z",
    fill: "#F5F3F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5663 19.8895C20.5663 24.2051 22.3136 28.1116 25.1388 30.9392L28.421 27.6544C26.4356 25.6672 25.2077 22.9215 25.2077 19.8895V19.7713C25.2396 16.7854 26.4612 14.0862 28.421 12.1247L25.1399 8.83978C22.3147 11.6674 20.5673 15.575 20.5673 19.8895H20.5663Z",
    fill: "#F5F3F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3828 27.152C27.5257 25.2933 26.3768 22.7255 26.3768 19.8897C26.3768 17.0538 27.5257 14.4861 29.3828 12.6273L32.6926 15.94C31.7204 16.9151 31.1045 18.2457 31.0614 19.7212C31.0564 19.7458 31.0533 19.7705 31.0533 19.7962C31.0533 19.8167 31.0552 19.8383 31.0583 19.8578V19.8897C31.0583 21.432 31.6835 22.8274 32.6926 23.8385V23.8393L29.3828 27.152Z",
    fill: "#F5F3F1"
  })));
};
export default SvgAppLogo;